import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { getCalApi } from "@calcom/embed-react";

interface BookingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const BookingModal = ({ isOpen, onClose }: BookingModalProps) => {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi();
      cal("ui", {
        theme: "dark",
        styles: { branding: { brandColor: "#D97706" } },
        hideEventTypeDetails: false,
        layout: "month_view"
      });
    })();
  }, []);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[60]"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            className="fixed inset-0 z-[70] flex items-center justify-center p-4 sm:p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-brand-dark border border-brand-border w-full max-w-4xl h-[80vh] rounded-2xl overflow-hidden relative shadow-2xl shadow-brand-primary/20">
              <button
                onClick={onClose}
                className="absolute top-4 right-4 z-10 p-2 bg-brand-base rounded-full text-slate-400 hover:text-white hover:bg-brand-border transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
              
              <div className="w-full h-full">
                <iframe
                  src="https://cal.com/tyler-kuchelmeister-e0drr4?theme=dark"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  title="Book a Call"
                ></iframe>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
